import axios from 'axios';

const config = {
  baseURL: ''
};

export default axios.create(config);
